import React, { useEffect, useState } from 'react';
import { Input, Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { modeType } from '../utils/RemoteUtils';
import { addDays, format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { formatValue } from '../utils/NumberUtils';
import Select from "react-select"
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css'
import { ja } from "date-fns/locale";

const BaseModal = ({ open, handleOpen, title, content, btnLeft, btnRight, btnStyle, handleLeft, handleRight }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} backdrop="static" keyboard={false}>
            <ModalBody className="py-md-4 px-md-5 p-2">
                <h6 className="text-center font-weight-bold pb-4">{title}</h6>
                {Array.isArray(content) ? content.map(el => {
                    return <p>{el}</p>
                }) : <p className="text-center py-3">{content}</p>}
            </ModalBody>
            <ModalFooter className="justify-content-around border-0 px-5 mb-3">
                <button className={btnStyle} onClick={handleLeft}>{btnLeft}</button>
                <button className={btnStyle} onClick={handleRight}>{btnRight}</button>
            </ModalFooter>
        </Modal>
    </>
}

const CustomModal = ({ open, handleOpen, title, content, btnLeft, btnMiddle, btnRight, handleLeft, handleRight, handleMiddle, status }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} backdrop="static" keyboard={false}>
            <ModalBody>
                <h2>{title}</h2>
                <p>{content}</p>
            </ModalBody>
            <ModalFooter>
                <button className='btn_left px-3' onClick={handleLeft}>{btnLeft}</button>
                <button className='btn_right px-3' disabled={status} onClick={handleMiddle}>{btnMiddle}</button>
                {/* <button className='btn_middle px-3' onClick={handleRight}>{btnRight}</button> */}
            </ModalFooter>
        </Modal>
    </>

}

const AddModal = ({ open, handleOpen, title, content, btnLeft, btnRight, handleLeft, handleRight }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} className='add__modal row' backdrop="static" keyboard={false}>
            <ModalBody>
                <h4 className='font-weight-bold'>{title}</h4>
                <p className='pt-3'>{content}</p>
            </ModalBody>
            <ModalFooter>
                <button className='btn_left1 px-3' onClick={handleLeft}>{btnLeft}</button>
                <button className='btn_right1 px-3' onClick={handleRight}>{btnRight}</button>
            </ModalFooter>
        </Modal>
    </>

}
const AddNotice = ({ open, handleOpen, title, content, btnLeft, btnRight, handleLeft, handleRight }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} className='add__notice row' backdrop="static" keyboard={false}>
            <ModalBody>
                <h4 className='font-weight-bold'>{title}</h4>
                <p className='pt-3'>{content}</p>
            </ModalBody>
            <ModalFooter>
                <button className='btn_left px-3' onClick={handleLeft}>{btnLeft}</button>
                <button className='btn_right px-3' onClick={handleRight}>{btnRight}</button>
            </ModalFooter>
        </Modal>
    </>

}
const NotificationModal = ({ open, content, handleOpen, modalStyle }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} className={modalStyle}>
            <div className="triangle-top"></div>
            <ModalBody className={`modal_notif ${typeof content === "string" && 'text-center'}`}>
                {content}
            </ModalBody>
        </Modal>
    </>
}

const InfoModal = ({ open, content, handleOpen, handleButton, button }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} className="infoModal" backdrop="static" keyboard={false}>
            <ModalBody className={`d-flex flex-column align-items-center justify-content-center ${content?.includes('に失敗') || content?.includes('つまでです。') ? "text-danger" : ""}`}>
                {content?.includes("\n") ? content.split('\n').map(str =>
                    <span>{str}</span>) : <p>{content}</p>}
            </ModalBody >
            <ModalFooter className='d-flex flex-column align-items-center'>
                <button className='btn_right px-3' onClick={handleButton}>{button}</button>
            </ModalFooter>
        </Modal>
    </>
}

const ConfirmationModal = ({ open, handleOpen, title, content, btnLeft, btnRight, handleLeft, handleRight, status }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} className="modal-content2" backdrop="static" keyboard={false}>
            <ModalBody>
                <h4 className='font-weight-bold'>{title}</h4>
                <p style={{ 'wordBreak': 'break-all' }}>{content}</p>
            </ModalBody>
            <ModalFooter>
                <button className='btn_left px-3' onClick={handleLeft}>{btnLeft}</button>
                <button className='btn_right px-3' disabled={status} onClick={handleRight}>{btnRight}</button>
            </ModalFooter>
        </Modal>
    </>

}

const CsvDownload = ({ open, handleOpen, content, text1, text2, text3, handleButton, loading }) => {
    // const [processing, setProcessing] = useState(false);
    const [selected, setSelected] = useState('default')

    useEffect(() => {
        if (!loading) {
            setSelected('default');
        }
    }, [loading]);

    const handleClick = () => {
        // if (processing) {
        //     return;
        // }

        // setProcessing(true);

        try {
            handleButton(selected);
        } catch (error) {
            console.error(error);
        }
    };
    const handleSelect = (e) => {
        setSelected(e.target.value);
    }

    return <>
        <Modal isOpen={open} toggle={handleOpen} className="csvModal" backdrop="static" keyboard={false}>
            <ModalBody className='pb-1 pt-4 px-4'>
                <h3>CSVダウンロード</h3>
                <p className=''>{content}</p>
                <select className='btn__select' value={selected} onChange={handleSelect}>
                    <option value="default">デフォルト集計値 </option>
                    <option value="30_minutes">
                        {text1}
                    </option>
                    <option value="minute_detail">
                        {text2}
                    </option>
                    <option value="30_minutes_detail">
                        {text3}
                    </option>
                </select>
                {/* <ul>
                        <li><button className='btn_right px-3' disabled={processing} onClick={() => { handleClick("minute") }} >{text1}</button></li>
                        <li><button className='btn_right px-3' disabled={processing} onClick={() => { handleClick("30_minutes") }}>{text2}</button></li>
                        <li><button className='btn_right px-3' disabled={processing} onClick={() => { handleClick("day") }}>{text3}</button></li>
                    </ul> */}
                {/* <div className='d-flex justify-content-center mt-4'>
                    {loading && <>
                        <Spinner style={{ width: '1.5rem', height: '1.5rem', paddingLeft: "3px" }} />
                    </>}
                </div> */}
            </ModalBody>
            <ModalFooter>
                {/* <button className='btn_left' disabled={loading} onClick={handleOpen}>キャンセル</button>
                <button className='btn_right' disabled={loading} onClick={handleClick}>ダウンロード</button> */}
                <button className='btn_left' onClick={handleOpen}>キャンセル</button>
                <button className='btn_right' onClick={handleClick}>ダウンロード</button>
            </ModalFooter>
        </Modal>
    </>
}

const TableModal = ({ open, handleOpen, title, content, mode, charge, chargeAmount, btnLeft, btnRight, handleLeft, handleRight, message, dateTime }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} backdrop="static" keyboard={false} className='tableModal'>
            <ModalBody>
                <h4 className="remote_modal">{title}</h4>
                <h5 className='remoteModal_msg'>{message}</h5>
                <h6 className='remoteMsg'>開始日時 : {dateTime}</h6>
                <div className='remoteEdit_div'>
                    <table className='remote_data'>
                        <thead>
                            <tr>
                                <th>デバイス名</th>
                                <th>モード</th>
                                <th>充放電電量[kWh]</th>
                                <th>充放電電力[kW]</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(content) && content.length > 0 && content.slice(content[0].value === '*' ? 1 : 0).map((data, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{data.value}</td>
                                        <td>{modeType(mode)}</td>
                                        <td>{charge !== null ? charge : '---'}</td>
                                        <td>{chargeAmount !== null ? chargeAmount : '---'}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </ModalBody>
            <ModalFooter className="">
                <button className='remote_buttonLeft' onClick={handleLeft}>{btnLeft}</button>
                <button className='remote_buttonRight' onClick={handleRight}>{btnRight}</button>
            </ModalFooter>
        </Modal>
    </>
}

const TableEditModal = ({ open, handleOpen, content, btnLeft, btnRight, handleLeft, handleRight, id, devices }) => {
    const [value, setValue] = useState({ ...content });
    const [date, setDate] = useState(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'yyyy-MM-dd'));
    const [time, setTime] = useState(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'HH:mm:ss'));
    const [invalidControls, setInvalidControls] = useState([]);
    const [invalidRate, setInvalidRate] = useState([]);
    const [options, setOptions] = useState([]);
    const [hasId, setHasId] = useState(true);
    const [timeFocus, setTimeFocus] = useState(false);
    const [openCalendar, setOpenCalendar] = useState(false);

    const handleDateChangeFrom = (e) => {
        let changedDate;
        if (e === null || e === '') {
            changedDate = ''
        } else {
            changedDate = format((new Date(e)), 'yyy-MM-dd');
        }
        setDate(changedDate);
    };

    const handleDateTime = () => {
        const newContent = { ...value };
        newContent.start_datetime = date + " " + time;
        setValue(newContent);
    }

    const updateControlMode = (index, newControlMode) => {
        const control = value.controls[index]
        let controls = [...value.controls]
        controls[index] = { ...control, control_mode: newControlMode }
        // Check if the newControlMode is either 'auto' or 'standby'
        if (newControlMode === 'auto' || newControlMode === 'standby') {
            // Remove 'target' and 'rate' properties from the control object
            delete controls[index].target;
            delete controls[index].rate;

            //Confition to Remove Higlight
            setInvalidControls(prevControls =>
                prevControls.filter(control => control.device_id !== value.controls[index].device_id)
            );
            setInvalidRate(prevControls =>
                prevControls.filter(control => control.device_id !== value.controls[index].device_id)
            );
        }
        // else {  // --- show error when user changes mode from auto or standby to charge or discharge

        //     setInvalidControls(controls.filter(control => !control.hasOwnProperty('target') && control.control_mode.toLowerCase() !== 'auto' && control.control_mode.toLowerCase() !== 'standby'));
        //     setInvalidRate(controls.filter(control => !control.hasOwnProperty('rate') && control.control_mode.toLowerCase() !== 'auto' && control.control_mode.toLowerCase() !== 'standby'));
        // } // ---
        setValue(Object.assign({}, value, {
            controls: controls
        }));
    }

    const updateTarget = (index, targetValue) => {
        const newTarget = Number(targetValue).toString();
        if (newTarget !== null) {
            if (newTarget === "NaN" || newTarget === '0') {
                const control = value.controls[index]
                let controls = [...value.controls]
                controls[index] = { ...control, target: newTarget === "0" ? newTarget : null }
                setValue(Object.assign({}, value, {
                    controls: controls
                }));
                // add into error if the inputted value is null or 0 (onchange)
                // setInvalidControls(controls.filter(control => control.target === "0" || control.target === null));
                setInvalidControls(prevControls => [...prevControls, ...controls.filter(control => control.target === "0" || control.target === null)])
            }
            if (newTarget <= 20 && newTarget !== "0") {
                const control = value.controls[index]
                let controls = [...value.controls]
                controls[index] = { ...control, target: newTarget }
                setValue(Object.assign({}, value, {
                    controls: controls
                }));

                //Confition to Remove Higlight
                setInvalidControls(prevControls =>
                    prevControls.filter(control => control.device_id !== value.controls[index].device_id)
                );

            }
        } else {
            const control = value.controls[index]
            let controls = [...value.controls]
            controls[index] = { ...control, target: newTarget }
            setValue(Object.assign({}, value, {
                controls: controls
            }));
            setInvalidControls(controls.filter(control => control.target === ''));
        }
    }

    const updateRate = (index, targetValue) => {
        const newRate = Number(targetValue).toString();
        if (newRate !== null) {
            if (newRate === "NaN" || newRate === '0') {
                const control = value.controls[index]
                let controls = [...value.controls]
                controls[index] = { ...control, rate: newRate === "0" ? newRate : null }
                setValue(Object.assign({}, value, {
                    controls: controls
                }));
                // add into error if the inputted value is null or 0 (onchange)
                // setInvalidRate(controls.filter(control => control.rate === "0" || control.rate === null));
                setInvalidRate(prevControls => [...prevControls, ...controls.filter(control => control.rate === "0" || control.rate === null)])
            }
            if (newRate <= 4 && newRate !== "0") {
                const control = value.controls[index]
                let controls = [...value.controls]
                controls[index] = { ...control, rate: newRate }
                setValue(Object.assign({}, value, {
                    controls: controls
                }));

                //Confition to Remove Higlight
                setInvalidRate(prevControls =>
                    prevControls.filter(control => control.device_id !== value.controls[index].device_id)
                );
            }
        } else {
            const control = value.controls[index]
            let controls = [...value.controls]
            controls[index] = { ...control, rate: newRate }
            setValue(Object.assign({}, value, {
                controls: controls
            }));
            setInvalidRate(controls.filter(control => control.rate === ''));
        }
    }

    useEffect(() => {
        // setValue(content);   
        setDate(Object.keys(content).length > 0 && content.start_datetime.split(" ")[0])
        setTime(Object.keys(content).length > 0 && content.start_datetime.split(" ")[1])
    }, [content])

    useEffect(() => {
        handleDateTime();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date, time])

    const handleDelete = (index) => {
        const newControls = [...value.controls];
        const deletedControl = newControls.splice(index, 1)[0];
        setValue({ ...value, controls: newControls });

        setInvalidControls(prevControls =>
            prevControls.filter(control => control.device_id !== deletedControl.device_id)
        );
        setInvalidRate(prevControls =>
            prevControls.filter(control => control.device_id !== deletedControl.device_id)
        );
        setOptions(devices.filter(device =>
            !newControls.some(control => control.device_id === device.value)
        ));
        if (deletedControl.device_id === '') {
            setHasId(true);
        }
    }

    const handleEdit = () => {
        const invalidControls = value.controls.filter(control => {
            if (control.control_mode.toLowerCase() === 'charge' || control.control_mode.toLowerCase() === 'discharge') {
                return control.target === undefined || control.target === null || control.target === '' || control.target === '0' || control.target === 0;
            }
            return false;
        });
        const invalidRate = value.controls.filter(control => {
            if (control.control_mode.toLowerCase() === 'charge' || control.control_mode.toLowerCase() === 'discharge') {
                return control.rate === undefined || control.rate === null || control.rate === '' || control.rate === '0' || control.rate === 0;
            }
            return false;
        });
        const hasEmptyDeviceId = value.controls.some(obj => obj.device_id === '');
        if (invalidControls.length === 0 && invalidRate.length === 0 && !hasEmptyDeviceId && !timeFocus) {
            handleRight(value);
        } else {
            setInvalidControls(invalidControls);
            setInvalidRate(invalidRate)
            if (hasEmptyDeviceId) {
                setHasId(false);
            }
        }
    };

    const addDevice = () => {
        const control = value.controls
        const hasEmptyDeviceId = control.some(obj => obj.device_id === '');
        // // --- to show error when adding a new device
        // setHasId(false); // ---
        if (!hasEmptyDeviceId) {
            setOptions(devices.filter(device =>
                !control.some(control => control.device_id === device.value)
            ));
            const newControl = {
                device_id: '', control_mode: 'charge'
            }
            let controls = [...value.controls]
            controls.push(newControl)
            setValue(Object.assign({}, value, {
                controls: controls
            }));
            // to show error when adding a new device
            // setInvalidControls(prevControls => [...prevControls, ...controls.filter(control => control.device_id === "")]);
            // setInvalidControls(controls.filter(control => control.device_id === ""));
            // setInvalidRate(prevControls => [...prevControls, ...controls.filter(control => control.device_id === "")]);
            // setInvalidRate(controls.filter(control => control.device_id === "")); // ---
        } else {
            setHasId(false);
        }
        // Delay the scroll action until after the table has updated its height
        setTimeout(() => {
            var container = document.getElementById("editTable");
            container.scrollTop = container.scrollHeight;
        }, 0);
    }

    const addDeviceId = (index, id) => {
        const control = value.controls[index]
        let controls = [...value.controls]
        controls[index] = { ...control, device_id: id }
        setValue(Object.assign({}, value, {
            controls: controls
        }));
        setHasId(true);

        if (invalidControls.length !== 0) {
            let invalids = [...invalidControls];
            invalids[index] = { ...control, device_id: id }
            invalids = invalids.filter(control => control.device_id !== '');
            setInvalidControls(invalids);
        }

        if (invalidRate.length !== 0) {
            let rateInvalid = [...invalidRate];
            rateInvalid[index] = { ...control, device_id: id }
            rateInvalid = rateInvalid.filter(control => control.device_id !== '');
            setInvalidRate(rateInvalid);
        }
    }

    // React Select Styles
    const customStyles = {
        control: styles => ({
            ...styles, backgroundColor: 'white', border: !hasId ? "1px solid #ff0000" : "1px solid #000", boxShadow: !hasId ? '0 0 0 1px #ff0000' : '0 0 0 1px #000',
            borderColor: !hasId ? '#ff0000' : '#000',
            '&:hover': {
                borderColor: !hasId ? '#ff0000' : '#000',
            },
            borderRadius: 5,
        }),
        dropdownIndicator: base => ({
            ...base,
            background: !hasId ? '#ff0000' : '#000',
            borderRadius: "6px",
            color: "#EFF8FE",
            position: 'static',
            padding: "5px 6px",
            margin: "0px 2px",
            width: 30,
            justifyContent: 'flex-end',
            svg: {
                width: 30,
            },
        }),
        menuList: (provided) => ({
            ...provided,
            scrollbarWidth: "thin",
            scrollbarColor: "#949494",
            fontSize: "12px",
            fontWeight: "400",

            "::-webkit-scrollbar": {
                width: "0.4rem",
                height: "0.4rem",
            },
            "::-webkit-scrollbar-thumb": {
                backgroundColor: "#c4c4c4",

                ":hover": {
                    backgroundColor: "#949494",
                }
            }
        }),
        indicatorSeparator: styles => ({
            ...styles,
            display: 'none',
        }),
    };

    const renderMessage = (hasId, invalidControls, invalidRate) => {
        if (!hasId || invalidControls.length > 0 || invalidRate.length > 0 || timeFocus) {
            return <span className='text-danger mt-2'>入力内容を確認してください。</span>;
        }
        return null;
    }

    return <>
        <Modal isOpen={open} toggle={handleOpen} backdrop="static" keyboard={false} className='editModal'>
            <ModalBody className="py-md-2 px-md-2 p-2">
                <span className='remote_id'>No. <span className='remote_id'>{id}</span></span>
                <div className='message-box'>
                    {renderMessage(hasId, invalidControls, invalidRate, timeFocus)}
                </div>
                <div className='remoteEdit_head'>開始日時</div>
                <div className='pt-2 remoteDTBox'>
                    <DatePicker className='remoteEdit_time remote_datepickerEdit'
                        showIcon
                        value={date}
                        portalId="root-portal"
                        locale={ja}
                        icon={
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='remote_datepickerSvg' onClick={() => setOpenCalendar(!openCalendar)}>
                                <rect x="3" y="6" width="18" height="15" rx="2" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" />
                                <path d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z" fill="#233C6B" fill-opacity="0.73" />
                                <path d="M7 3L7 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                <path d="M17 3L17 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                <rect x="7" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                <rect x="7" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                <rect x="13" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                <rect x="13" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                            </svg>
                        }
                        minDate={new Date()}
                        maxDate={addDays(new Date(), 30)}
                        onChange={(e) => { handleDateChangeFrom(e); setOpenCalendar(false); }}
                        open={openCalendar}
                        // onInputClick={() => setOpenCalendar(!openCalendar)}
                        onClickOutside={() => setOpenCalendar(false)}
                    />
                    <div className='timeWrapper'>
                        <input type="time" bsSize="sm" className={`ml-2 remoteEdit_time ${timeFocus && 'empty'}`}
                            onChange={(e) => {
                                setTime(e.target.value + ':00');
                                if (e.target.value !== '') {
                                    setTimeFocus(false);
                                } else {
                                    setTimeFocus(true);
                                }
                            }}
                            value={time.split(":").slice(0, -1).join(":")}
                        // onKeyDown={(e) => e.preventDefault()}
                        />
                        {/* <img src="/img/timer.svg" className="timerIconModal" /> */}
                    </div>
                    <span> <span className='remoteEdit_time'>※現在時刻から30分以内は即時実行されます</span></span>
                </div>
                <div className='remoteEdit_div mt-3' id='editTable'>
                    <table className='remote_dataEdit'>
                        <thead>
                            <tr>
                                <th className={devices.length !== value.controls.length ? "" : "addIcon"}
                                >{devices.length !== value.controls.length && <svg width="17" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }} onClick={() => addDevice()}>
                                    <rect width="20" height="20" rx="10" fill="#233C6B" fill-opacity="0.73" />
                                    <path d="M9.38636 15.5174V4.27805H10.9045V15.5174H9.38636ZM4.52131 10.6523V9.14311H15.7695V10.6523H4.52131Z" fill="white" />
                                </svg>}

                                    デバイス名</th>
                                <th>モード</th>
                                <th>充放電電量[kWh]</th>
                                <th>充放電電力[kW]</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(value).length > 0 && value.controls && value.controls.map((element, i) => {
                                return (
                                    <tr key={i} className={element.device_id !== "" ? '' : 'newAddedRow'}>
                                        <td>
                                            <div style={{ display: "flex" }}>
                                                {value.controls.length > 1 && <svg width="11" height="12" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="trash-icon" style={{ cursor: "pointer", marginTop: "0px" }} onClick={() => handleDelete(i)}>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 4.44772 0.447715 4 1 4H23C23.5523 4 24 4.44772 24 5C24 5.55228 23.5523 6 23 6H1C0.447715 6 0 5.55228 0 5Z" fill="#FF0000" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1C6 0.447715 6.44772 0 7 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H7C6.44772 2 6 1.55228 6 1Z" fill="#FF0000" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3.55228 4 4 4.44772 4 5V24H20V5C20 4.44772 20.4477 4 21 4C21.5523 4 22 4.44772 22 5V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H4C3.46957 26 2.96086 25.7893 2.58579 25.4142C2.21071 25.0391 2 24.5304 2 24V5C2 4.44772 2.44772 4 3 4Z" fill="#FF0000" />
                                                </svg>}&nbsp;&nbsp;{element.device_id !== "" ? <span className='remoteMsg deviceid'>{element.device_id}</span> :
                                                    <Select
                                                        options={[...options]}
                                                        isMulti={false}
                                                        isSearchable={false}
                                                        onChange={(e) => addDeviceId(i, e.value)}
                                                        styles={customStyles}
                                                        menuPosition='fixed'
                                                    />
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            <span className="remote__div remote__charge mt-1"> <input type="radio" id="charge" className="checkboxScale" checked={element.control_mode.toLowerCase() === "charge"} value={"charge"} onChange={() => {
                                                updateControlMode(i, "charge");
                                            }} /><span className="remote_mode pl-2">充電</span></span>
                                            <span className="remote__div remote__discharge mt-1"> <input type="radio" id="discharge" className="checkboxScale" checked={element.control_mode.toLowerCase() === "discharge"} value={"discharge"} onChange={() => {
                                                updateControlMode(i, "discharge");
                                            }} /><span className="remote_mode pl-2">放電</span></span>
                                            <span className="remote__div remote__chargecycle mt-1"> <input type="radio" id="standby" className="checkboxScale" checked={element.control_mode.toLowerCase() === "standby"} value={"standby"} onChange={() => {
                                                updateControlMode(i, "standby");
                                            }} /><span className="remote_mode pl-2">待機</span></span>
                                            <span className="remote__div remote__chargeAmount mt-1"> <input type="radio" id="auto" className="checkboxScale" checked={element.control_mode.toLowerCase() === "auto"} value={"auto"} onChange={() => {
                                                updateControlMode(i, "auto");
                                            }} /><span className="remote_mode pl-2">自動</span></span>
                                        </td>
                                        <td><Input className={`remoteEdit_rate ${invalidControls.some(control => control.device_id === element.device_id) ? 'empty' : ''}`} type="number" min={0.1} step={0.1} max={20} value={element.target ? formatValue(element.target, 1) : ''} disabled={element.control_mode.toLowerCase() === 'auto' || element.control_mode.toLowerCase() === 'standby'}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if (value.includes('.')) {
                                                    updateTarget(i, (Math.floor(Number(value) * 10) / 10).toString())
                                                } else {
                                                    updateTarget(i, parseFloat(parseFloat(value).toFixed(1)));
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.code === 'Minus' || e.code === 'NumpadSubtract' || e.code === 'Equal' || e.code === 'NumpadAdd' || e.code === "KeyE") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            placeholder={element.control_mode.toLowerCase() === 'auto' || element.control_mode.toLowerCase() === 'standby' ? '---' : '0.1~20'}
                                            required={element.control_mode.toLowerCase() === 'charge' || element.control_mode.toLowerCase() === 'discharge' || !element.target} /></td>
                                        < td > <Input className={`remoteEdit_rate ${invalidRate.some(control => control.device_id === element.device_id) ? 'empty' : ''}`} type="number" min={0.1} step={0.1} max={4} value={element.rate ? formatValue(element.rate, 1) : ''} disabled={element.control_mode.toLowerCase() === 'auto' || element.control_mode.toLowerCase() === 'standby'}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if (value.includes('.')) {
                                                    updateRate(i, (Math.floor(Number(value) * 10) / 10).toString());
                                                } else {
                                                    updateRate(i, parseFloat(parseFloat(value).toFixed(1)));
                                                }
                                                // if (e.target.value >= 0 && e.target.value <= 4) {
                                                // updateRate(i, parseFloat(parseFloat(e.target.value).toFixed(2)));
                                                // }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.code === 'Minus' || e.code === 'NumpadSubtract' || e.code === 'Equal' || e.code === 'NumpadAdd' || e.code === "KeyE") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            placeholder={element.control_mode.toLowerCase() === 'auto' || element.control_mode.toLowerCase() === 'standby' ? '---' : '0.1~4'}
                                            required={element.control_mode.toLowerCase() === 'charge' || element.control_mode.toLowerCase() === 'discharge' || !element.rate} /></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </ModalBody>
            <ModalFooter className="">
                <button className='remote_buttonLeft' onClick={() => {
                    handleLeft();
                }}>{btnLeft}</button>
                <button className='remote_buttonRight' onClick={() => {
                    handleEdit();
                }}>{btnRight}</button>
            </ModalFooter>
        </Modal >
    </>
}

const ConfirmEditModal = ({ open, handleOpen, title, content, btnLeft, btnRight, handleLeft, handleRight, message, id, display }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} backdrop="static" keyboard={false} className='tableModal'>
            <ModalBody>
                <h4 className="font-weight-bold title-editModal">{title}</h4>
                <h5 className='remoteModal_msg'>{message}</h5>
                <h6 className='remote_id'>No. <span>{id}</span></h6>
                {display === undefined && <h6 className='remoteMsg'>開始日時 : {content.start_datetime}</h6>}
                <div className='remoteEdit_div'>
                    <table className='remote_data'>
                        <thead>
                            <tr>
                                <th>デバイス名</th>
                                <th>モード</th>
                                <th>充放電電量[kWh]</th>
                                <th>充放電電力[kW]</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(content).length > 0 && content.controls.map((element, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            {element.device_id}
                                        </td>
                                        <td>{modeType(element.control_mode)}</td>
                                        <td>{element.target ? formatValue((element.target)) : '---'}</td>
                                        <td>{element.rate ? formatValue((element.rate)) : '---'}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </ModalBody>
            <ModalFooter className="">
                <button className='remote_buttonLeft' onClick={handleLeft}>{btnLeft}</button>
                <button className='remote_buttonRight' onClick={handleRight}>{btnRight}</button>
            </ModalFooter>
        </Modal>
    </>
}

const SuccessModal = ({ open, content, handleOpen, handleButton }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} className="infoModal" backdrop="static" keyboard={false}>
            <ModalBody className={`d-flex flex-column align-items-center justify-content-center ${content?.includes('が失敗') ? "text-danger" : "successModal"}`}>
                <p className='remoteModal_status'>{content}</p>

            </ModalBody>
            <ModalFooter className='d-flex flex-column align-items-center'>
                <button className='remote_buttonRight px-3' onClick={handleButton}>OK</button>
            </ModalFooter>
        </Modal>
    </>
}


const LoadingModal = ({ open, content, handleOpen }) => {
    return <>
        <Modal isOpen={open} toggle={handleOpen} className="infoModal" backdrop="static" keyboard={false}>
            <ModalBody className='d-flex flex-column align-items-center justify-content-center successModal'>
                {content}
                <Spinner className='my-4' style={{ width: '2.5rem', height: '2.5rem', paddingLeft: "3px" }} />

            </ModalBody>
        </Modal>
    </>
}


export { BaseModal, AddModal, CustomModal, NotificationModal, InfoModal, ConfirmationModal, CsvDownload, TableModal, TableEditModal, ConfirmEditModal, SuccessModal, LoadingModal, AddNotice };